import { Box, Button, Container, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

const REDIRECT_SECONDS = 6;

interface ErrorFallbackFriendlyProps {
  onGoHome: () => void;
}

export const ErrorFallbackFriendly = ({ onGoHome }: ErrorFallbackFriendlyProps) => {
  const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) {
      onGoHome();
      return;
    }
    const timer = window.setTimeout(() => setSecondsLeft((prev) => prev - 1), 1000);
    return () => window.clearTimeout(timer);
  }, [secondsLeft, onGoHome]);

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 4,
          p: 4,
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
          bgcolor: 'background.paper',
        }}>
        <Typography variant="h5" color="primary" gutterBottom sx={{ fontWeight: 600 }}>
          Algo salió mal
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Ocurrió un error inesperado. Te llevaremos al inicio para que puedas continuar.
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
          Redirigiendo al inicio en <strong>{secondsLeft}</strong> {secondsLeft === 1 ? 'segundo' : 'segundos'}…
        </Typography>
        <Button variant="contained" color="primary" onClick={onGoHome}>
          Ir al inicio ahora
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorFallbackFriendly;
